import React, { useEffect } from "react";
import { CloseCircle } from "iconsax-reactjs";
import "./reels.css";

/** Playback for a single reel. Escape and a backdrop click both close. */
export default function ReelVideoModal({ reel, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!reel) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal reel-video-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Reel video"
      >
        <div className="modal-header">
          <h2>Reel preview</h2>
          <button type="button" className="btn-icon" onClick={onClose} aria-label="Close video">
            <CloseCircle size={20} variant="Linear" />
          </button>
        </div>
        <div className="reel-stage reel-video-stage">
          {/* autoPlay without muted is blocked by browser policy; the controls
              let the reviewer unmute immediately. */}
          <video
            className="reel-video"
            src={reel.videoUrl}
            poster={reel.thumbnailUrl}
            controls
            autoPlay
            muted
            playsInline
          />
        </div>
        {reel.caption ? <p className="reel-video-caption">{reel.caption}</p> : null}
      </div>
    </div>
  );
}
